import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useTranslation } from 'react-i18next';

export default function CookiePolicy() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {currentLang === 'pt' ? 'Política de Cookies' : currentLang === 'es' ? 'Política de Cookies' : 'Cookie Policy'}
          </h1>
          <p className="text-gray-600 mb-8">
            {currentLang === 'pt' ? 'Última atualização: 15 de janeiro de 2024' : currentLang === 'es' ? 'Última actualización: 15 de enero de 2024' : 'Last updated: January 15, 2024'}
          </p>

          <div className="prose prose-lg max-w-none">
            {currentLang === 'pt' ? (
              <>
                <section className="mb-8">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    A FARWAYS utiliza cookies e tecnologias similares no seu website para melhorar a sua experiência de navegação, analisar o tráfego do site e personalizar conteúdos. Esta Política de Cookies explica o que são cookies, como os utilizamos e como pode controlá-los.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. O que são Cookies?</h2>
                  <p className="text-gray-700 mb-4">
                    Cookies são pequenos ficheiros de texto que são armazenados no seu dispositivo (computador, tablet ou telemóvel) quando visita um website. Os cookies permitem que o website reconheça o seu dispositivo e armazene algumas informações sobre as suas preferências ou ações passadas.
                  </p>
                  
                  <div className="bg-orange-50 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Tipos de Cookies por Duração:</h3>
                    <ul className="list-disc pl-6 text-gray-700 space-y-2">
                      <li><strong>Cookies de Sessão:</strong> Temporários, eliminados quando fecha o navegador</li>
                      <li><strong>Cookies Persistentes:</strong> Permanecem no dispositivo por um período definido ou até serem eliminados manualmente</li>
                    </ul>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Tipos de Cookies que Utilizamos</h2>
                  
                  <div className="space-y-6">
                    <div className="border-l-4 border-orange-500 pl-6 bg-gray-50 p-5 rounded-r-lg">
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">2.1 Cookies Estritamente Necessários</h3>
                      <p className="text-gray-700 mb-3">
                        <strong>Finalidade:</strong> Essenciais para o funcionamento do website. Sem estes cookies, o site não pode funcionar corretamente.
                      </p>
                      <p className="text-gray-700 mb-3"><strong>Exemplos:</strong></p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-1">
                        <li>Cookies de autenticação e segurança</li>
                        <li>Cookies de preferências de idioma</li>
                        <li>Cookies de carrinho de compras</li>
                      </ul>
                      <p className="text-gray-700 mt-3">
                        <strong>Base Legal:</strong> Interesse legítimo (Artigo 6.º, n.º 1, alínea f) do RGPD)
                      </p>
                      <p className="text-gray-700">
                        <strong>Duração:</strong> Sessão ou até 12 meses
                      </p>
                    </div>

                    <div className="border-l-4 border-orange-500 pl-6 bg-gray-50 p-5 rounded-r-lg">
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">2.2 Cookies de Desempenho e Análise</h3>
                      <p className="text-gray-700 mb-3">
                        <strong>Finalidade:</strong> Recolhem informações sobre como os visitantes utilizam o website, permitindo-nos melhorar o seu funcionamento.
                      </p>
                      <p className="text-gray-700 mb-3"><strong>Exemplos:</strong></p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-1">
                        <li>Google Analytics (análise de tráfego)</li>
                        <li>Cookies de contagem de visitantes</li>
                        <li>Cookies de tempo de carregamento de páginas</li>
                      </ul>
                      <p className="text-gray-700 mt-3">
                        <strong>Base Legal:</strong> Consentimento (Artigo 6.º, n.º 1, alínea a) do RGPD)
                      </p>
                      <p className="text-gray-700">
                        <strong>Duração:</strong> Até 24 meses
                      </p>
                    </div>

                    <div className="border-l-4 border-orange-500 pl-6 bg-gray-50 p-5 rounded-r-lg">
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">2.3 Cookies de Funcionalidade</h3>
                      <p className="text-gray-700 mb-3">
                        <strong>Finalidade:</strong> Permitem que o website se lembre das suas escolhas e forneça funcionalidades melhoradas e personalizadas.
                      </p>
                      <p className="text-gray-700 mb-3"><strong>Exemplos:</strong></p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-1">
                        <li>Preferências de idioma</li>
                        <li>Preferências de visualização</li>
                        <li>Dados de formulários preenchidos</li>
                      </ul>
                      <p className="text-gray-700 mt-3">
                        <strong>Base Legal:</strong> Consentimento (Artigo 6.º, n.º 1, alínea a) do RGPD)
                      </p>
                      <p className="text-gray-700">
                        <strong>Duração:</strong> Até 12 meses
                      </p>
                    </div>

                    <div className="border-l-4 border-orange-500 pl-6 bg-gray-50 p-5 rounded-r-lg">
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">2.4 Cookies de Marketing e Publicidade</h3>
                      <p className="text-gray-700 mb-3">
                        <strong>Finalidade:</strong> Utilizados para apresentar anúncios relevantes e medir a eficácia das campanhas publicitárias.
                      </p>
                      <p className="text-gray-700 mb-3"><strong>Exemplos:</strong></p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-1">
                        <li>Google Ads</li>
                        <li>Facebook Pixel</li>
                        <li>Cookies de remarketing</li>
                      </ul>
                      <p className="text-gray-700 mt-3">
                        <strong>Base Legal:</strong> Consentimento (Artigo 6.º, n.º 1, alínea a) do RGPD)
                      </p>
                      <p className="text-gray-700">
                        <strong>Duração:</strong> Até 13 meses
                      </p>
                    </div>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Cookies de Terceiros</h2>
                  <p className="text-gray-700 mb-4">
                    Alguns cookies são colocados por serviços de terceiros que aparecem nas nossas páginas. Não controlamos estes cookies e recomendamos que consulte os websites destes terceiros para mais informações.
                  </p>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Principais Terceiros:</h3>
                    <div className="space-y-4">
                      <div>
                        <p className="text-gray-700 font-semibold">Google Analytics</p>
                        <p className="text-gray-600 text-sm">Análise de tráfego e comportamento dos utilizadores</p>
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 text-sm">
                          Política de Privacidade do Google
                        </a>
                      </div>
                      <div>
                        <p className="text-gray-700 font-semibold">Google Maps</p>
                        <p className="text-gray-600 text-sm">Serviço de mapas integrado</p>
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 text-sm">
                          Política de Privacidade do Google
                        </a>
                      </div>
                      <div>
                        <p className="text-gray-700 font-semibold">Facebook</p>
                        <p className="text-gray-600 text-sm">Integração de redes sociais e publicidade</p>
                        <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 text-sm">
                          Política de Privacidade do Facebook
                        </a>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Como Gerir e Eliminar Cookies</h2>
                  <p className="text-gray-700 mb-4">
                    Pode controlar e/ou eliminar cookies conforme desejar. Pode eliminar todos os cookies que já estão no seu dispositivo e pode configurar a maioria dos navegadores para impedir que sejam colocados.
                  </p>

                  <div className="bg-orange-50 p-6 rounded-lg mb-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Gestão de Cookies no Navegador:</h3>
                    <div className="space-y-3">
                      <div>
                        <p className="text-gray-700 font-semibold">Google Chrome</p>
                        <p className="text-gray-600 text-sm">Definições &gt; Privacidade e segurança &gt; Cookies e outros dados de sites</p>
                      </div>
                      <div>
                        <p className="text-gray-700 font-semibold">Mozilla Firefox</p>
                        <p className="text-gray-600 text-sm">Opções &gt; Privacidade e Segurança &gt; Cookies e dados de sites</p>
                      </div>
                      <div>
                        <p className="text-gray-700 font-semibold">Safari</p>
                        <p className="text-gray-600 text-sm">Preferências &gt; Privacidade &gt; Cookies e dados de websites</p>
                      </div>
                      <div>
                        <p className="text-gray-700 font-semibold">Microsoft Edge</p>
                        <p className="text-gray-600 text-sm">Definições &gt; Cookies e permissões do site &gt; Cookies e dados armazenados</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-lg">
                    <p className="text-gray-700 mb-3">
                      <strong>Importante:</strong> Se desativar ou recusar cookies, algumas partes do nosso website podem não funcionar corretamente ou pode ter uma experiência de navegação menos personalizada.
                    </p>
                    <p className="text-gray-700">
                      Para mais informações sobre cookies e como geri-los, visite: <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600">www.allaboutcookies.org</a>
                    </p>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Consentimento para Cookies</h2>
                  <p className="text-gray-700 mb-4">
                    Quando visita o nosso website pela primeira vez, apresentamos um banner de cookies que lhe permite:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                    <li>Aceitar todos os cookies</li>
                    <li>Rejeitar cookies não essenciais</li>
                    <li>Personalizar as suas preferências de cookies</li>
                  </ul>
                  <p className="text-gray-700 mb-4">
                    O seu consentimento é válido por 12 meses, após o qual será solicitado novamente.
                  </p>
                  <p className="text-gray-700">
                    Pode alterar as suas preferências de cookies a qualquer momento através das definições do seu navegador ou contactando-nos diretamente.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookies e Dispositivos Móveis</h2>
                  <p className="text-gray-700 mb-4">
                    Os cookies também são utilizados em dispositivos móveis. As definições de cookies em dispositivos móveis podem ser geridas através das configurações do navegador móvel ou das definições do dispositivo.
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Gestão em Dispositivos Móveis:</h3>
                    <div className="space-y-2">
                      <p className="text-gray-700"><strong>iOS (Safari):</strong> Definições &gt; Safari &gt; Privacidade e Segurança</p>
                      <p className="text-gray-700"><strong>Android (Chrome):</strong> Definições &gt; Privacidade &gt; Limpar dados de navegação</p>
                    </div>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Tecnologias Similares</h2>
                  <p className="text-gray-700 mb-4">
                    Além de cookies, utilizamos outras tecnologias similares:
                  </p>
                  <div className="space-y-4">
                    <div className="bg-gray-50 p-5 rounded-lg">
                      <h3 className="font-semibold text-gray-800 mb-2">Web Beacons (Pixels)</h3>
                      <p className="text-gray-700">Pequenas imagens gráficas incorporadas em páginas web ou emails para rastrear visualizações e interações.</p>
                    </div>
                    <div className="bg-gray-50 p-5 rounded-lg">
                      <h3 className="font-semibold text-gray-800 mb-2">Local Storage</h3>
                      <p className="text-gray-700">Armazenamento local no navegador para guardar dados de forma mais persistente que os cookies.</p>
                    </div>
                    <div className="bg-gray-50 p-5 rounded-lg">
                      <h3 className="font-semibold text-gray-800 mb-2">Session Storage</h3>
                      <p className="text-gray-700">Armazenamento temporário de dados durante a sessão de navegação.</p>
                    </div>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Atualizações desta Política</h2>
                  <p className="text-gray-700 mb-4">
                    Podemos atualizar esta Política de Cookies periodicamente para refletir mudanças nas nossas práticas ou por outros motivos operacionais, legais ou regulamentares.
                  </p>
                  <p className="text-gray-700">
                    Recomendamos que reveja esta página regularmente para se manter informado sobre como utilizamos cookies. A data da última atualização está indicada no topo desta página.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Mais Informações</h2>
                  <p className="text-gray-700 mb-4">
                    Para mais informações sobre como tratamos os seus dados pessoais, consulte a nossa <a href="/politica-de-privacidade" className="text-orange-500 hover:text-orange-600 font-semibold">Política de Privacidade</a>.
                  </p>
                  <p className="text-gray-700 mb-4">
                    Esta Política de Cookies está em conformidade com:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>Regulamento (UE) 2016/679 (RGPD)</li>
                    <li>Lei n.º 58/2019, de 8 de agosto</li>
                    <li>Diretiva 2002/58/CE (Diretiva ePrivacy)</li>
                    <li>Lei n.º 41/2004, de 18 de agosto (Lei das Comunicações Eletrónicas)</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contactos</h2>
                  <div className="bg-orange-50 p-6 rounded-lg">
                    <p className="text-gray-700 mb-4">
                      Se tiver questões sobre a nossa utilização de cookies ou esta política, contacte-nos:
                    </p>
                    <p className="text-gray-700 mb-2"><strong>Email:</strong> geral@farways.pt</p>
                    <p className="text-gray-700 mb-2"><strong>Telefone:</strong> +351 937 545 000</p>
                    <p className="text-gray-700 mb-2"><strong>Website:</strong> farways.pt</p>
                    <p className="text-gray-700"><strong>Morada:</strong> Rua João de Deus, 28C, 8000-368 Faro, Portugal</p>
                  </div>
                </section>

                <div className="bg-gray-100 p-6 rounded-lg mt-8">
                  <p className="text-sm text-gray-600 text-center">
                    FARWAYS é uma marca registada de Alves e Frade, Lda. | NIPC 505413850 | RNAVT 8586
                  </p>
                </div>
              </>
            ) : currentLang === 'es' ? (
              <>
                <section className="mb-8">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    FARWAYS utiliza cookies y tecnologías similares en su sitio web para mejorar su experiencia de navegación, analizar el tráfico del sitio y personalizar contenidos. Esta Política de Cookies explica qué son las cookies, cómo las utilizamos y cómo puede controlarlas.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. ¿Qué son las Cookies?</h2>
                  <p className="text-gray-700 mb-4">
                    Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (ordenador, tablet o móvil) cuando visita un sitio web. Las cookies permiten que el sitio web reconozca su dispositivo y almacene información sobre sus preferencias o acciones pasadas.
                  </p>
                  
                  <div className="bg-orange-50 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Tipos de Cookies por Duración:</h3>
                    <ul className="list-disc pl-6 text-gray-700 space-y-2">
                      <li><strong>Cookies de Sesión:</strong> Temporales, eliminadas cuando cierra el navegador</li>
                      <li><strong>Cookies Persistentes:</strong> Permanecen en el dispositivo por un período definido o hasta que se eliminen manualmente</li>
                    </ul>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Tipos de Cookies que Utilizamos</h2>
                  <p className="text-gray-700 mb-4">
                    Utilizamos diferentes tipos de cookies en nuestro sitio web para diversos propósitos.
                  </p>
                </section>

                <p className="text-gray-700 text-center mt-8">
                  [Contenido completo disponible en portugués e inglés]
                </p>

                <div className="bg-gray-100 p-6 rounded-lg mt-8">
                  <p className="text-sm text-gray-600 text-center">
                    FARWAYS es una marca registrada de Alves e Frade, Lda. | NIPC 505413850 | RNAVT 8586
                  </p>
                </div>
              </>
            ) : (
              <>
                <section className="mb-8">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    FARWAYS uses cookies and similar technologies on its website to improve your browsing experience, analyze site traffic and personalize content. This Cookie Policy explains what cookies are, how we use them and how you can control them.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. What are Cookies?</h2>
                  <p className="text-gray-700 mb-4">
                    Cookies are small text files that are stored on your device (computer, tablet or mobile phone) when you visit a website. Cookies allow the website to recognize your device and store some information about your preferences or past actions.
                  </p>
                  
                  <div className="bg-orange-50 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Types of Cookies by Duration:</h3>
                    <ul className="list-disc pl-6 text-gray-700 space-y-2">
                      <li><strong>Session Cookies:</strong> Temporary, deleted when you close the browser</li>
                      <li><strong>Persistent Cookies:</strong> Remain on the device for a defined period or until manually deleted</li>
                    </ul>
                  </div>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Types of Cookies We Use</h2>
                  <p className="text-gray-700 mb-4">
                    We use different types of cookies on our website for various purposes.
                  </p>
                </section>

                <p className="text-gray-700 text-center mt-8">
                  [Full content available in Portuguese and Spanish]
                </p>

                <div className="bg-gray-100 p-6 rounded-lg mt-8">
                  <p className="text-sm text-gray-600 text-center">
                    FARWAYS is a registered trademark of Alves e Frade, Lda. | Tax ID 505413850 | RNAVT 8586
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
